import {
  getAverageDealSizeFormField,
  getQuotaAmountFormField,
  getQuotaAttainmentPerLastYearFormField,
  getQuotaAttainmentPerPeriodFormField,
  getQuotaTypeFormField,
} from '@/components/partials/jobs/JobsInquiryForm/utils/formFields';
import type {
  JobsFormField,
  JobsSectionModels,
} from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';

export default ({ inquiry }: JobsSectionModels): JobsFormField[] => {
  return [
    getQuotaAmountFormField({ inquiry }),
    getQuotaAttainmentPerPeriodFormField(),
    getQuotaAttainmentPerLastYearFormField(),
    getAverageDealSizeFormField(),
    getQuotaTypeFormField({ inquiry, dropdownDirection: 'top' }),
  ];
};
